import React from 'react'
import styled from 'styled-components';
import i18n from '../i18n';
import { BoldTitle, CardTitle } from '../styled/Card';
import therapistImgSrc from '../icons/therapist-illustration.svg';
import warnIcoSrc from '../icons/warn-ico.svg';

const SuggestedCharge = (props) => {
  const {
    avg_hour_charge: averageHourCharge,
    income_goal_month: incomeGoal,
    suggested_hour_charge: suggestedCharge,
    working_hours_goal_month: workingHours,
  } = props.data;

  return (
    <Container>
      <ImageWrapper>
        <img src={therapistImgSrc} alt="therapist image" />
        <IWCol>
          <CardTitle mb={5}>
            {i18n.t('suggestedCharge.suggested')}
          </CardTitle>
          <BoldTitle mb={35}>{ suggestedCharge }</BoldTitle>
          <CardTitle mb={5}>
            {i18n.t('suggestedCharge.average')}
          </CardTitle>
          <BoldTitle>{ averageHourCharge }</BoldTitle>
        </IWCol>
      </ImageWrapper>
      <WarnText>
        <img src={warnIcoSrc} alt="warning icon"/>
        <span>
          {i18n.t('suggestedCharge.conclusion', { suggestedCharge, workingHours, incomeGoal })}
        </span>
      </WarnText>
    </Container>
  )
};

export default SuggestedCharge;

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  > img {
    width: 270px;
    height: auto;
  }
`;

const IWCol = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const WarnText = styled.div`
  display: flex;
  margin-top: 30px;
  align-items: center;
  > img {
    width: 20px;
    height: 20px;
  }
  > span {
    color: #FD9448;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.02em;
    padding-left: 15px;
  }
`
